var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWave1InvertedShadow = function SvgWave1InvertedShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    filter: "url(#wave-1-inverted-shadow_svg__a)",
    enableBackground: "new 0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "wave-1-inverted-shadow_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1341.4 151.4C1159 151.4 1087.2 71 912 71c-117.8 0-209.7 67.5-393.5 67.5-142.2 0-212.6-38.8-324.6-38.8S-10 135.6-10 135.6v10s91.9-35.9 203.9-35.9 182.4 38.8 324.6 38.8C702.3 148.5 794.2 81 912 81c175.2 0 247 80.4 429.4 80.4 87.6 0 158-12.9 268.6-53.1v-10c-110.6 40.2-181 53.1-268.6 53.1z"
  })));
};
export default SvgWave1InvertedShadow;